import './CardGrid.css';

function CardGrid({ children, rows = 1, columns = 5 }) {


    /* generate named areas for grid-template-areas based on rows and columns */
    const namedAreas = Array.from({ length: rows }, (_, row) => 
      Array.from({ length: columns }, (_, col) => `a${row + 1}${col + 1}`).join(' ')
    ).join('" "').slice(0, -2); /* remove last extra quote */   

    return (
        <div className="card-grid" style={{'--rows': rows, '--columns': columns, '--area-template': `"${namedAreas}"`}}>
            {children}
        </div>
    );
}

export default CardGrid;